import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["header", "content", "element"];

	openContent() {
		this.headerTarget.classList.add("hidden");
		this.contentTarget.classList.remove("hidden");
	}

	toggleContent() {
		if (this.elementTarget.hasAttribute("data-group-toggle")) {
			this.elementTarget.removeAttribute("data-group-toggle");
		} else {
			this.elementTarget.setAttribute("data-group-toggle", true);
		}
	}
}
